function Testimonial(props){
    return (
        <article className="testimonial">
                    <div className="testimonial--image"><img src={props.src} alt="emily" /></div>
                    <p className="txt-gray-dark testimonial--para txtCtr">
  {props.txt}
  </p>
  <div className="testimonial--bottom">  
  <h4 className="fs-heading-small fw-black txtCtr">{props.name}</h4>
  <h5 className="fs-heading-mini txtCtr txt-gray-light family-barlow">{props.title}</h5>
  </div>


                </article>
    )
}
export default Testimonial;